<span class="{{cssClass}}">{{ _name }}</span>
